import TermApi from '@apis/term/TermApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';

const termQueries = createQueryKeys('terms', {
    list: (termCategoryId: string) => ({
        queryKey: ['terms', termCategoryId],
        queryFn: () => TermApi.getTermsByCategory(termCategoryId),
    }),
    main: (termCategoryId: string) => ({
        queryKey: ['main', termCategoryId],
        queryFn: () => TermApi.getMainTermByCategory(termCategoryId),
    }),
});

export default termQueries;
